import React, { useContext } from 'react'
import styled from 'styled-components'
import { WATERMARK_MARGIN } from '../../../constants'
import CreationToolWatermarkPosition from '../../../types/watermark'
import { CreationSourceEditorContext } from '../manager'

const Container = styled.div`
    overflow: hidden;
    pointer-events: none;
    position: absolute;
`

const Watermark = styled.img`
    position: absolute;
`

type Props = {
    canvasScale?: number
}

const getWatermarkPosition = (position: CreationToolWatermarkPosition, margin: number) => {
    switch (position) {
        case CreationToolWatermarkPosition.TopLeft:
            return { left: margin, top: margin }
        case CreationToolWatermarkPosition.TopRight:
            return { right: margin, top: margin }
        case CreationToolWatermarkPosition.BottomLeft:
            return { left: margin, bottom: margin }
        case CreationToolWatermarkPosition.BottomRight:
            return { right: margin, bottom: margin }
    }
}

const CreationToolsSourceEditorArtboardWatermark = ({ canvasScale = 1 }: Props) => {
    const { watermark, crop, source } = useContext(CreationSourceEditorContext)
    const margin = Math.round((crop.width * WATERMARK_MARGIN) / canvasScale)
    const watermarkWidth = Math.round(watermark?.width || source.width * 0.2)

    return watermark ? (
        <Container
            style={{
                left: Math.round(crop.x / canvasScale),
                top: Math.round(crop.y / canvasScale),
                width: Math.round(crop.width / canvasScale),
                height: Math.round(crop.height / canvasScale),
            }}
        >
            <Watermark
                {...{
                    src: watermark.url,
                    alt: '',
                    style: {
                        ...getWatermarkPosition(watermark.position, margin),
                        width: `${Math.round((watermarkWidth / source.width) * 100)}%`,
                    },
                }}
            />
        </Container>
    ) : null
}

export default CreationToolsSourceEditorArtboardWatermark
